import Image1 from "../../assets/products/TransBillBook-New-img/login-img.png";
import Image2 from "../../assets/products/TransBillBook-New-img/Dashboard-img.png";
import Image3 from "../../assets/products/TransBillBook-New-img/User-img.png";
import Image4 from "../../assets/products/TransBillBook-New-img/Masters-img.png";
import Image5 from "../../assets/products/TransBillBook-New-img/Transaction-LR-img.png";
import Image6 from "../../assets/products/TransBillBook-New-img/Transaction-Vendor-img.png";
import Image7 from "../../assets/products/TransBillBook-New-img/Reports-img.png";
import Image8 from "../../assets/products/TransBillBook-New-img/Invoice-img.png";

import Video1 from "../../assets/products/TransBillBook-New-img/User-creating-video.mp4";
import Video2 from "../../assets/products/TransBillBook-New-img/LR-creating-video.mp4";
import Video3 from "../../assets/products/TransBillBook-New-img/Memo-creating-video.mp4";
import Video4 from "../../assets/products/TransBillBook-New-img/Bill-creating-video.mp4";
import Video5 from "../../assets/products/TransBillBook-New-img/Reports-creating-video.mp4";
import Video6 from "../../assets/products/TransBillBook-New-img/Masters-creating-video.mp4";


import ImageSlider from "../common/ImageSlider";
import { Fade, Slide } from "react-awesome-reveal";
import "./index.css";

import votersync_about from "../../assets/VoterSync-about.svg";

import PlayIcon from "../../assets/play-btn.svg";
import AdminsIcon from "../../assets/products/VoterSync/Module/Admin.png";
import MastersIcon from "../../assets/products/VoterSync/Module/Masters.png";
import TransactionsIcon from "../../assets/products/VoterSync/Module/Transactions.png";
import UtilityIcon from "../../assets/products/VoterSync/Module/Utility.png";

import AuditIcon from "../../assets/VoterSync/Modules/audit.svg";
import ReportsIcon1 from "../../assets/VoterSync/Modules/report.png";

import { Dialog, IconButton } from "@mui/material";
import { uniqueId } from "lodash";
import { useState } from "react";
import GotoTop from "../common/GotoTop";
import MultiCarousel from "../common/MultiCarousel";

import ContactCTA from "../contact/contactCTA";
import PricingCards from "./priceCard";

const VThumb1 = Image3;
const VThumb2 = Image5;
const VThumb3 = Image6;
const VThumb4 = Image8;
const VThumb5 = Image7;
const VThumb6 = Image4;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 575 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 575, min: 0 },
    items: 1,
  },
};

const TransBillbook = () => {
  const data = [
    { img: Image1, alt: "Image1" },
    { img: Image2, alt: "Image2" },
    { img: Image3, alt: "Image3" },
    { img: Image4, alt: "Image4" },
    { img: Image5, alt: "Image5" },
    { img: Image6, alt: "Image6" },
    { img: Image7, alt: "Image7" },
  ];

  const json = [
    {
      title: <>Administrator</>,
      description: (
        <>
          The Administrator module controls user management, role-based access,
          and screen permissions, ensuring secure and customizable system
          governance
        </>
      ),
    },
    {
      title: <>Masters</>,
      description: (
        <>
          The Masters module manages all foundational static data.
          <ul className="list-disc pl-5">
            <li>Groups, Financial Ledger, Non Financial Ledger</li>
            <li>Product Master, Tariff Master, Location Master</li>
            <li>Vehicle Master, Bank Master</li>
          </ul>
        </>
      ),
    },
    {
      title: <>Transactions</>,
      description: (
        <>
          The Transaction module centralizes all commercial operations.
          <ul className="list-disc pl-5">
            <li>LR/Vendor Entry, Invoice/Bill Preparation, Receipt Voucher</li>
            <li>Payment Voucher, Contra Voucher</li>
            <li>Debit Note Entry, Credit Note Entry</li>
          </ul>
        </>
      ),
    },
    {
      title: <>Reports</>,
      description: (
        <>
          Download any report in PDF or Excel format with one click.
          <ul className="list-disc pl-5">
            <li>Account Ledger, Account Group Ledger, Vendor Register</li>
            <li>LR Register, Invoice/Bill Register, Debitor & Creditor Outstanding Summary Report</li>
            <li>Bank Book, Debitor & Creditor Oustanding Detail report</li>
            <li>Profit & Loss report, Cash Book report, Balance Sheet report, </li>
          </ul>
        </>
      ),
    },
    {
      title: <>Utility</>,
      description: <>We can easily take backup of Financial year and Database.</>,
    },
  ];

  const modules = [
    { title: "Administrator", img: AdminsIcon },
    { title: "Masters", img: MastersIcon },
    { title: "Transactions", img: TransactionsIcon },
    { title: "Reports", img: ReportsIcon1 },
    { title: "Audits", img: AuditIcon },
    { title: "Utility", img: UtilityIcon },
  ];

  const videoData = [
    { node: <RenderVideo title={"Admins"} src={Video1} poster={VThumb1} /> },
    { node: <RenderVideo title={"Masters"} src={Video6} poster={VThumb6} /> },
    { node: <RenderVideo title={"Transacts"} src={Video2} poster={VThumb2} /> },
    { node: <RenderVideo title={"Transacts"} src={Video3} poster={VThumb3} /> },
    { node: <RenderVideo title={"Transacts"} src={Video4} poster={VThumb4} /> },
    { node: <RenderVideo title={"Reports"} src={Video5} poster={VThumb5} /> },
  ];

  const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
      e.currentTarget?.href.split("#")[1]
    );

    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="pt-4">
      <div className="md:flex bg-transbillbook md:h-[400px] ">
        <section className="flex flex-col justify-center">
          <div className="text-center tb-title text-6xl md:text-7xl flex justify-center font-semibold">
            <Fade triggerOnce>
              <p className="w-fit text-[var(--dark-blue)] leading-[1.5]">
                TransBillbook
              </p>
            </Fade>
          </div>

          <div className="text-center font-bold tracking-widest text-xl md:text-2xl bg-[var(--dark-blue)] text-white py-2">
            <Fade triggerOnce delay={400}>
              <span>The complete transport billing management system</span>
            </Fade>
          </div>
        </section>
        <div className="md:w-[65%] slider-container bg-[var(--dark-blue)] flex justify-center">
          <div className="w-full max-md:mb-[40px]">
            <Fade triggerOnce className="h-full relative" delay={600}>
              <ImageSlider data={data} />
            </Fade>
          </div>
        </div>
      </div>

      <div className="w-full px-5 sm:max-lg:px-2 my-7 sm:my-14">
        <p className="text-center mb-4 md:mb-0 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
          <Fade triggerOnce className="h-full relative" delay={610}>
            About Our Platform
          </Fade>
        </p>

        <div className="lg:flex lg:gap-2 w-full">
          <div className="w-full">
            <div className="w-full">
              <Fade triggerOnce className="h-full relative" delay={610}>
                <img
                  src={votersync_about}
                  alt=""
                  className="lg:min-w-[600px] animate-on-appear"
                />
              </Fade>
            </div>
          </div>

          <div>
            <Fade triggerOnce className="h-full relative" delay={650}>
              <div className="flex flex-col justify-center vs-about-us-content h-full font-notosans text-md sm:text-xl font-semibold text-[#333e49]">
                <p className="mb-6">
                  Our Transport Billing App brings efficiency, transparency, and
                  security to the billing process for transport and logistics
                  companies. Our mission is to empower operators with tools that
                  streamline data entry (Masters).
                </p>
                <p className="mb-6">
                  Automate billing and invoicing workflows (Transactions),
                  generate insightful financial and operational analytics
                  (Reports), and offer useful utilities like reminders, document
                  exports, and accounting integrations. Together, these features
                  ensure accurate billing, faster collections, and complete
                  visibility into your fleet's performance.
                </p>
                <p>
                  <a
                    className="text-blue-800 underline"
                    href="#contact"
                    onClick={onPress}
                  >
                    Join us
                  </a>
                  &nbsp; in shaping the future of participatory governance.
                </p>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      <div className="keyh-main-wrapper w-full px-5 sm:px-24 sm:my-14">
        <div className="keyh-wrapper">
          <div className="keyh-box py-4 sm:py-6">
            <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
              <Fade triggerOnce className="h-full relative" delay={700}>
                Salient Features
              </Fade>
            </p>

            <div className="keyh-content pt-4">
              {json.map((item, index) => {
                return (
                  <div
                    className="appear-on-scroll content-wrapper"
                    key={`${index}`}
                  >
                    <Fade triggerOnce delay={index * 150}>
                      <div className="line">
                        <div className="">
                          <p className="title text-[1.3rem] md:text-[2.1vw]">
                            <div className="w-fit text-content text-[var(--dark-blue)]">
                              {item.title}
                            </div>
                          </p>
                          <p
                            className="description w-full text-[1rem] md:text-[1.6vw]"
                            data-text={item.description}
                          >
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </Fade>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-5 sm:px-24">
        <div className="w-full flex justify-center items-center py-10">
          <h2 className="text-[#324054] text-4xl font-bold transform translate-y-10 mb-4">
            Our Clients
          </h2>
        </div>

        <div className="gallery-section relative h-[220px] my-12 -mx-5 sm:-mx-24 w-[calc(100%+40px)] sm:w-[calc(100%+192px)] overflow-hidden flex items-center shadow-inner">
          <style>
            {`
      @keyframes smoothScroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .pause-on-hover:hover {
        animation-play-state: paused !important;
      }
    `}
          </style>

          <div className="absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-black/20 to-transparent pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-black/20 to-transparent pointer-events-none"></div>

          <div
            className="pause-on-hover flex gap-10 items-center cursor-pointer"
            style={{
              display: 'flex',
              width: 'max-content',
              animation: 'smoothScroll 35s linear infinite'
            }}
          >
            {[...Array(2)].map((_, i) => (
              <div key={i} className="flex gap-10">
                {[
                  "Gokul Roadways",
                  "Siddhivinayak Transport",
                  "Mahaveer Cargo Movers",
                  "Shivganga Roadlines",
                  "Harshali Roadlines",
                  "Jyotirling Transport",
                  "Satish Cargo Carrier",
                  "Transway Cargo Logistic",
                  "G.N.Roadlines",
                  "Shyam Logistic Corporation",
                  "A.K.Hanuman Translift",
                  "Vandana Trans Logistics",
                  "Tiwari & Sons Transport",
                  "Omkar Cargo Movers",
                  "Galav Road Carrier",
                  "Pooja Corporation Of India.",
                  "Veeru Roadlines",
                  "Sagar Transport Company",
                  "AndhraOddisa Roadlines"
                ].map((name, index) => {

                  let firstLine = "";
                  let secondLine = "";

                  if (name === "G.N.Roadlines") {
                    firstLine = "G.N";
                    secondLine = "Roadlines";
                  }
                  else if (name === "Shyam Logistic Corporation") {
                    firstLine = "Shyam Logistic";
                    secondLine = "Corporation";
                  }
                  else if (name === "S.N.Jangra Container Services") {
                    firstLine = "S.N Jangra ";
                    secondLine = "Container Services";
                  }
                  else if (name === "Tiwari & Sons Transport") {
                    firstLine = "Tiwari & Sons";
                    secondLine = "Transport";
                  }
                  else {
                    const words = name.split(" ");
                    firstLine = words[0];
                    secondLine = words.slice(1).join(" ");
                  }

                  return (
                    <div
                      key={index}
                      className="w-[180px] h-[110px] bg-white flex flex-col items-center justify-between text-center p-3 shadow-2xl rounded-xl flex-shrink-0 transition-all duration-300 hover:scale-110 hover:z-20 border-b-4 border-yellow-500"
                    >
                      <div className="pt-1">
                        <div className="text-[#324054] text-lg font-extrabold leading-tight">
                          {firstLine}
                        </div>
                        <div className="text-[#324054] text-lg font-extrabold leading-tight">
                          {secondLine}
                        </div>
                      </div>

                      <div className="text-black-500 text-[14px] pb-1">
                        Navi Mumbai
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className=" w-full px-5 sm:px-24 pt-1 pb-5 md:pb-10 sm:mb-14 gallery-section">
        <div className="py-4 sm:py-6">
          <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-white">
            <Fade triggerOnce className="h-full relative" delay={700}>
              Gallery
            </Fade>
          </p>
        </div>

        <div>
          <MultiCarousel
            data={videoData}
            responsiveSettings={responsive}
            carouselContainerClassname="video-carousel-container"
            listItemClassname="video-list-item"
          />
        </div>
      </div>

      <div className=" w-full px-5 sm:px-24 mt-6 sm:my-14">
        <div className="py-4 sm:py-6">
          <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
            <Fade triggerOnce className="h-full relative" delay={700}>
              Modules integrated in TransBillbook
            </Fade>
          </p>
        </div>

        <div>
          <div>
            <div className="modules-grid">
              {modules.map((obj, index) => {
                return (
                  <div
                    className="modules-card bg-[var(--dark-blue)]"
                    key={uniqueId()}
                  >
                    <Slide triggerOnce direction="up" delay={index * 40}>
                      <div className="img-wrap flex justify-center appear-on-scroll">
                        <img
                          src={obj.img}
                          alt="img"
                          className="bg-white border border-t border-b-0  border-gray-400 "
                        />
                      </div>
                      <div className="title text-center pb-2 pt-[4px] text-xs lg:text-lg tracking-widest font-semibold text-white">
                        {obj.title}
                      </div>
                    </Slide>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <PricingCards />

        <div>
          <Fade triggerOnce className="h-full relative" delay={700}>
            <ContactCTA />
          </Fade>
        </div>
      </div>

      <GotoTop />
    </div>
  );
};
const RenderVideo = ({ title, src, poster }) => {
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    setPlaying(true);
  };

  const closePreview = () => {
    setPlaying(false);
  };

  return (
    <>
      <div className="z-[2] video-title bg-[var(--dark-blue)] border-2 border-orange-400 min-w-[30ch] text-center pt-1 lg:pt-2 pb-1 text-xs lg:text-lg font-bold text-white absolute right-[-12ch] top-[1ch] tracking-wider rotate-45">
        {title}
      </div>
      <div className="video-wrapper relative overflow-hidden ">
        <img
          src={PlayIcon}
          alt="play"
          title="click to Play"
          className="play-icon absolute w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] bg-slate-200 rounded-[50vw] shadow-lg"
          onClick={handlePlay}
        />
        <img
          src={poster}
          alt="thumbnail"
          className="max-sm:min-h-[100px] max-sm:min-w-[150px]"
          title="click to Play"
          onClick={handlePlay}
        />
      </div>

      {playing && (
        <Dialog
          sx={{
            zIndex: "100000",
          }}
          open={playing}
          onClose={closePreview}
          maxWidth="lg"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <IconButton
            onClick={closePreview}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "black",
              backgroundColor: "white",
              border: "1px solid black",
              paddingInline: "10px",
              zIndex: 2,
            }}
          >
            <button className="leading-[1]" title="close">
              ✕
            </button>
          </IconButton>

          <div className="p-1 lg:p-6 bg-slate-200 overflow-visible">
            <div className="relative overflow-visible">
              <video src={src} controls muted />
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default TransBillbook;